import { FileInfo } from "@robe/core";
import { AspectRatio, BoxProps, Flex, Link } from "@xcorejs/ui";
import { ReactNode } from "react";
import { ShortVideo as ShortVideoType, ShortVideoValues } from "xcore/types";
import ShortVideoBase from "./ShortVideoBase";

type ThumbnailSize =
  | { width: 410; height: 230 }
  | { width: 740; height: 416 }
  | { width: 1290; height: 726 }
  | { width: 410; height: 410 }
  | { width: 740; height: 740 }
  | { width: 1290; height: 1290 }
  | { width: 230; height: 410 }
  | { width: 416; height: 740 }
  | { width: 726; height: 1290 };

/**
 * This type is needed because before using this component, it is firstly needed to pick one of the ratios for video in shortVideo content type.
 * Thus, ShortVideoValues type is unusable because the values need to change.
 */
export type ShortVideoValuesRestructured = Pick<ShortVideoValues, "description" | "internalDes" | "title"> & {
  shortVideo: FileInfo;
  videoThumbnail?: FileInfo<ThumbnailSize>;
  autoPlay?: boolean;
  loop?: boolean;
  mute?: boolean;
  noControl?: boolean;
  darkBackground?: boolean;
  ratio?: number;
};

export type ShortVideoRestructured = Pick<ShortVideoType, "id" | "type" | "title"> & {
  values: ShortVideoValuesRestructured;
};

interface ShortVideoProps {
  video: ShortVideoValuesRestructured;
  id: number;
  ratio?: number;
  targetURL?: string;
  newWindow?: boolean;
  carouselIndex?: number;
  button?: ReactNode;
  _button?: BoxProps;
}

const ShortVideo = ({ video, id, ratio, targetURL, newWindow, carouselIndex, button, _button, ...props }: ShortVideoProps) => {
  return (
    <AspectRatio ratio={ratio ?? video.ratio ?? 9 / 16} height="100%" background="black" {...props}>
      {/* there has to be this ternary, because <Link /> without href prevents video from being played/paused  */}
      {targetURL ? (
        <Link
          width="100%"
          display="flex"
          v="simple"
          border="0"
          href={targetURL}
          target={newWindow ? "_blank" : "_self"}
          cursor={targetURL?.length > 1 ? "pointer !important" : "default !important"}
        >
          <ShortVideoBase video={video} id={id} carouselIndex={carouselIndex} />
        </Link>
      ) : (
        <ShortVideoBase video={video} id={id} carouselIndex={carouselIndex} />
      )}

      <Flex position="absolute" bottom={{ _: "30%", sm: "25%", xl: "21%" }} width="100%" justifyContent="center" {..._button}>
        {button}
      </Flex>
    </AspectRatio>
  );
};

export default ShortVideo;
